import React from 'react';
import Box from '../Box';
import IconButton from '../IconButton';
import { LeftCaretIcon, RightCaretIcon } from '../Icon';
import Typography from '../Typography';
import Button from '../Button';
var CalendarControls = function (_a) {
    var date = _a.date, onChange = _a.onChange;
    return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "space-between" },
        React.createElement(Box, null,
            React.createElement(IconButton, { "aria-label": "previous-month", size: "small", onClick: function () {
                    onChange('minus');
                } },
                React.createElement(LeftCaretIcon, { fontSize: "inherit" })),
            React.createElement(IconButton, { "aria-label": "next-month", size: "small", onClick: function () {
                    onChange('plus');
                } },
                React.createElement(RightCaretIcon, { fontSize: "inherit" }))),
        React.createElement(Typography, { "aria-label": "month-display", variant: "h4", align: "center" }, date.toLocaleString('en-US', {
            month: 'long',
            year: 'numeric',
        })),
        React.createElement(Button, { "aria-label": "select-today", size: "medium", color: "vitality", variant: "text", onClick: function () {
                onChange('today');
            } }, "Today")));
};
export default CalendarControls;
